import { Box } from '@mantine/core';
import classes from './LogoLoader.styles.tsx.module.css';
import Logo from '../icons/Logo';
import { isDtiHosted, isRevProHosted, isTKTEdgeHosted, isVictoryLiveHosted } from '../../utils/whitelabel-consts';

interface LogoLoaderProps {
  size?: number;
  brand?: 'default' | 'dti' | 'revpro' | 'victorylive' | 'tktedge';
}

export default function LogoLoader({
  size = 60,
  brand = isDtiHosted ? 'dti' : isRevProHosted ? 'revpro' : isVictoryLiveHosted ? 'victorylive' : isTKTEdgeHosted ? 'tktedge' : 'default',
}: LogoLoaderProps) {
  return (
    <Box pos="absolute" top={0} left={0} right={0} bottom={0} className={classes.logoLoaderWrapper}>
      <div className={classes.innerWrapper}>
        <div className={classes.loaderCircle} style={brand === 'victorylive' ? { paddingTop: '10px' } : undefined}>
          <Logo size={size} brand={brand === 'dti' ? 'dti' : brand === 'revpro' ? 'revpro' : brand === 'victorylive' ? 'victorylive' : brand === 'tktedge' ? 'tktedge' : 'bn'} />
        </div>
      </div>
    </Box>
  );
}
